
import TopBar from "../master/menu/TopBar";
import LeftSidebar from "../master/menu/LeftSidebar";
import PageWrapper from "../master/menu/PageWrapper";
import { useEffect, useRef } from "react";

const MainWrapper = ({mainWrapperAttributes, themeSettings, showSpinnerLoader, getDataUser, getDataMenu, getDataZonasAgencias }) => {
    const scrollSidebar = useRef(null);
    const initialized = useRef(false);
    let scrollbarInstance = null;
    let adminCleanup = null;
    useEffect(() => {
        if (!initialized.current) { // <- Verificar si ya se ejecutó
            adminCleanup = initAdministration();
            initializeAdminSettings();
            initSidebar();
            initCustom();
            initialized.current = true;
        }

        // Cleanup
        return () => {
            adminCleanup?.();
            if (scrollbarInstance.current) {
                scrollbarInstance.current.destroy();
                scrollbarInstance.current = null;
            }
            // Remover todos los event listeners de jQuery
            $(window).off('resize');
            $('.sidebartoggler').off('click');
            $('.nav-toggler').off('click');
            // Agregar más limpieza según sea necesario
        };
    }, []);

    const initAdministration = () => {
        const resizeHandlers = [];
        if (window.$) {
            $.fn.AdminSettings = function (settings) {
                var myid = this.attr("id");
                var defaults = {
                    Theme: true,
                    Layout: 'vertical',
                    LogoBg: 'skin1',
                    NavbarBg: 'skin6',
                    SidebarType: 'mini-sidebar',
                    SidebarColor: 'skin1',
                    SidebarPosition: false,
                    HeaderPosition: false,
                    BoxedLayout: false,
                };

                var settings = $.extend({}, defaults, settings);
                var AdminSettings = {
                    AdminSettingsInit: function () {
                        AdminSettings.ManageTheme();
                        AdminSettings.ManageThemeLayout();
                        AdminSettings.ManageThemeBackground();
                        AdminSettings.ManageSidebarType();
                        AdminSettings.ManageSidebarColor();
                        AdminSettings.ManageSidebarPosition();
                        AdminSettings.ManageBoxedLayout();
                    },
                    ManageTheme: function () {
                        var themeview = settings.Theme;
                        switch (settings.Layout) {
                            case 'vertical':
                                if (themeview) {
                                    $('body').attr("data-theme", 'dark');
                                    $("#theme-view").prop("checked", true);
                                } else {
                                    $('#' + myid).attr("data-theme", 'light');
                                    $("body").prop("checked", false);
                                }
                                break;
                            default:
                        }
                    },
                    ManageThemeLayout: function () {
                        switch (settings.Layout) {
                            case 'horizontal':
                                $('#' + myid).attr("data-layout", "horizontal");
                                break;
                            case 'vertical':
                                $('#' + myid).attr("data-layout", "vertical");
                                if (scrollSidebar.current) {
                                    scrollbarInstance = PerfectScrollbar.initialize(scrollSidebar.current, {});
                                }
                                break;
                            default:
                        }
                    },
                    ManageThemeBackground: function () {
                        function setlogobg() {
                            var lbg = settings.LogoBg;
                            if (lbg) {
                                $('#' + myid + ' .topbar .top-navbar .navbar-header').attr("data-logobg", lbg);
                            } else {
                                $('#' + myid + ' .topbar .top-navbar .navbar-header').attr("data-logobg", "skin1");
                            }
                        }
                        setlogobg();
                        function setnavbarbg() {
                            var nbg = settings.NavbarBg;
                            if (nbg) {
                                $('#' + myid + ' .topbar .navbar-collapse').attr("data-navbarbg", nbg);
                                $('#' + myid + ' .topbar').attr("data-navbarbg", nbg);
                                $('#' + myid).attr("data-navbarbg", nbg);
                            } else {
                                $('#' + myid + ' .topbar .navbar-collapse').attr("data-navbarbg", "skin1");
                                $('#' + myid + ' .topbar').attr("data-navbarbg", "skin1");
                                $('#' + myid).attr("data-navbarbg", "skin1");
                            }
                        }
                        setnavbarbg();
                    },
                    ManageSidebarType: function () {   
                        switch (settings.SidebarType) {
                            case 'full':
                                $('#' + myid).attr("data-sidebartype", "full");
                                var setsidebartype = function () {
                                    var width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width;
                                    if (width < 1170) {
                                        $("#main-wrapper").attr("data-sidebartype", "mini-sidebar");
                                        $("#main-wrapper").addClass("mini-sidebar");
                                    } else {
                                        $("#main-wrapper").attr("data-sidebartype", "full");
                                        $("#main-wrapper").removeClass("mini-sidebar");
                                    }
                                };
                                $(window).ready(setsidebartype);
                                $(window).on("resize", setsidebartype);
                                $('.sidebartoggler').on("click", function () {
                                    console.log('settings.SidebarType 1', $("#main-wrapper").hasClass("mini-sidebar"));
                       
                                    $("#main-wrapper").toggleClass("mini-sidebar");
                                    if ($("#main-wrapper").hasClass("mini-sidebar")) {
                                        $(".sidebartoggler").prop("checked", true);
                                        $("#main-wrapper").attr("data-sidebartype", "mini-sidebar");
                                    } else {
                                        $(".sidebartoggler").prop("checked", false);
                                        $("#main-wrapper").attr("data-sidebartype", "full");
                                    }
                                });
                                break;

                            case 'mini-sidebar':
                                console.log('myId', myid);
                                
                                $('#' + myid).attr("data-sidebartype", "mini-sidebar");
                                $('.sidebartoggler').on("click", function () {
                                    $("#main-wrapper").toggleClass("mini-sidebar");
                                    if ($("#main-wrapper").hasClass("mini-sidebar")) {
                                        $(".sidebartoggler").prop("checked", true);
                                        $("#main-wrapper").attr("data-sidebartype", "full");
                                    } else {
                                        $(".sidebartoggler").prop("checked", false);
                                        $("#main-wrapper").attr("data-sidebartype", "mini-sidebar");
                                    }
                                });
                                break;

                            case 'iconbar':
                                $('#' + myid).attr("data-sidebartype", "iconbar");
                                var setsidebartype = function () {
                                    var width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width;
                                    if (width < 1170) {
                                        $("#main-wrapper").attr("data-sidebartype", "mini-sidebar");
                                        $("#main-wrapper").addClass("mini-sidebar");
                                    } else {
                                        $("#main-wrapper").attr("data-sidebartype", "iconbar");
                                        $("#main-wrapper").removeClass("mini-sidebar");
                                    }
                                };

                                $(window).ready(setsidebartype);
                                $(window).on("resize", setsidebartype);
                                $('.sidebartoggler').on("click", function () {
                                    $("#main-wrapper").toggleClass("mini-sidebar");
                                    if ($("#main-wrapper").hasClass("mini-sidebar")) {
                                        $(".sidebartoggler").prop("checked", true);
                                        $("#main-wrapper").attr("data-sidebartype", "mini-sidebar");
                                    } else {
                                        $(".sidebartoggler").prop("checked", false);
                                        $("#main-wrapper").attr("data-sidebartype", "iconbar");
                                    }
                                });
                                break;

                            case 'overlay':
                                $('#' + myid).attr("data-sidebartype", "overlay");
                                var setsidebartype = function () {
                                    var width = (window.innerWidth > 0) ? window.innerWidth : this.screen.width;
                                    if (width < 767) {
                                        $("#main-wrapper").attr("data-sidebartype", "mini-sidebar");
                                        $("#main-wrapper").addClass("mini-sidebar");
                                    } else {
                                        $("#main-wrapper").attr("data-sidebartype", "overlay");
                                        $("#main-wrapper").removeClass("mini-sidebar");
                                    }

                                };

                                $(window).ready(setsidebartype);
                                $(window).on("resize", setsidebartype);

                                $('.sidebartoggler').on("click", function () {
                                    $("#main-wrapper").toggleClass("show-sidebar");

                                });
                                break;
                            default:
                        }
                    },
                    ManageSidebarColor: function () {
                        function setsidebarbg() {
                            var sbg = settings.SidebarColor;
                            if (sbg) {
                                $('#' + myid + ' .left-sidebar').attr("data-sidebarbg", sbg);
                            } else {
                                $('#' + myid + ' .left-sidebar').attr("data-sidebarbg", "skin1");
                            }
                        }
                        setsidebarbg();
                    },
                    ManageSidebarPosition: function () {
                        var sidebarposition = settings.SidebarPosition;
                        var headerposition = settings.HeaderPosition;
                        switch (settings.Layout) {
                            case 'vertical':
                                if (sidebarposition) {
                                    $('#' + myid).attr("data-sidebar-position", 'fixed');
                                    $("#sidebar-position").prop("checked", true);
                                } else {
                                    $('#' + myid).attr("data-sidebar-position", 'absolute');
                                    $("#sidebar-position").prop("checked", false);
                                }

                                if (headerposition) {
                                    $('#' + myid).attr("data-header-position", 'fixed');
                                    $("#header-position").prop("checked", true);
                                } else {
                                    $('#' + myid).attr("data-header-position", 'relative');
                                    $("#header-position").prop("checked", false);
                                }
                                break;

                            default:
                        }

                    },
                    ManageBoxedLayout: function () {
                        var boxedlayout = settings.BoxedLayout;
                        switch (settings.Layout) {
                            case 'vertical':
                                if (boxedlayout) {
                                    $('#' + myid).attr("data-boxed-layout", 'boxed');
                                    $("#boxed-layout").prop("checked", true);
                                } else {
                                    $('#' + myid).attr("data-boxed-layout", 'full');
                                    $("#boxed-layout").prop("checked", false);
                                }

                                break;

                            case 'horizontal':
                                if (boxedlayout) {
                                    $('#' + myid).attr("data-boxed-layout", 'boxed');
                                    $("#boxed-layout").prop("checked", true);
                                } else {
                                    $('#' + myid).attr("data-boxed-layout", 'full');
                                    $("#boxed-layout").prop("checked", false);

                                }
                                break;
                            default:
                        }
                    }
                };
                AdminSettings.AdminSettingsInit();
            };

             // Capturar referencia de los event handlers
            const setsidebartype = () => {/* ... */};
            $(window).on('resize', setsidebartype);
            resizeHandlers.push(() => $(window).off('resize', setsidebartype));

        };


        return () => {
            resizeHandlers.forEach(cleanup => cleanup());
            // Destruir la instancia cuando el componente se desmonte
            if (scrollbarInstance) {
                scrollbarInstance.destroy();
            }
        };
    };

    const initializeAdminSettings = () => {
        $(function () {
            "use strict";
            $("#main-wrapper").AdminSettings({
                Theme: (mainWrapperAttributes['data-theme'] == 'light'?false:true), // this can be true or false ( true means dark and false means light ),
                Layout: mainWrapperAttributes['data-layout'],
                LogoBg: 'skin6', // You can change the Value to be skin1/skin2/skin3/skin4/skin5/skin6 
                NavbarBg: mainWrapperAttributes['data-navbarbg'], // You can change the Value to be skin1/skin2/skin3/skin4/skin5/skin6
                SidebarType: mainWrapperAttributes['data-sidebartype'], // You can change it full / mini-sidebar / iconbar / overlay
                SidebarColor: 'skin6', // You can change the Value to be skin1/skin2/skin3/skin4/skin5/skin6
                SidebarPosition: (mainWrapperAttributes['data-header-position'] == 'fixed'?true:false), // it can be true / false ( true means Fixed and false means absolute )
                HeaderPosition: (mainWrapperAttributes['data-header-position'] == 'fixed'?true:false), // it can be true / false ( true means Fixed and false means absolute )
                BoxedLayout: (mainWrapperAttributes['data-boxed-layout'] == 'full'?false:true), // it can be true / false ( true means Boxed and false means Fluid ) 
            });
        });
    };

    const initSidebar = () => {
        if (window.$) {
            // console.log('init sidebar...');
            $(function () {
                // "use strict";
                var url = window.location + "";
                var path = url.replace(window.location.protocol + "//" + window.location.host + "/", "");
                var element = $('ul#sidebarnav a').filter(function () {
                    return this.href === url || this.href === path;// || url.href.indexOf(this.href) === 0;
                });
                
                element.parentsUntil(".sidebar-nav").each(function (index) {
                    if ($(this).is("li") && $(this).children("a").length !== 0) {
                        $(this).children("a").addClass("active");
                        // $(this).parent("ul#sidebarnav").length === 0
                        //     ? $(this).addClass("active")
                        //     : $(this).addClass("selected");
                    } else if (!$(this).is("ul") && $(this).children("a").length === 0) {
                        // $(this).addClass("selected");
                    } else if ($(this).is("ul")) {
                        $(this).addClass('in');
                    }
                });

                element.addClass("active");
                $('#sidebarnav a').on('click', function (e) {
                    if (!$(this).hasClass("active")) {
                        // hide any open menus and remove all other classes
                        $("ul", $(this).parents("ul:first")).removeClass("in");
                        $("a", $(this).parents("ul:first")).removeClass("active");

                        // open our new menu and add the open class
                        $(this).next("ul").addClass("in");
                        $(this).addClass("active");

                    } else if ($(this).hasClass("active")) {
                        $(this).removeClass("active");
                        $(this).parents("ul:first").removeClass("active");
                        $(this).next("ul").removeClass("in");
                    }
                })
                $('#sidebarnav >li >a.has-arrow').on('click', function (e) {
                    e.preventDefault();
                });

            });
        }
    };

    const initCustom = () => {
        if (window.$) {
            $(function () {
                "use strict";

                $(".preloader").fadeOut();
                // ============================================================== 
                // Theme options
                // ==============================================================     
                // ============================================================== 
                // sidebar-hover
                // ==============================================================

                $(".left-sidebar").hover(
                    function () {
                        $(".navbar-header").addClass("expand-logo");
                    },
                    function () {
                        $(".navbar-header").removeClass("expand-logo");
                    }
                );
                // this is for close icon when navigation open in mobile view
                $(".nav-toggler").on('click', function () {
                    $("#main-wrapper").toggleClass("show-sidebar");
                    $(".nav-toggler i").toggleClass("ti-menu");
                });
                $(".nav-lock").on('click', function () {
                    $("body").toggleClass("lock-nav");
                    $(".nav-lock i").toggleClass("mdi-toggle-switch-off");
                    $("body, .page-wrapper").trigger("resize");
                });
                $(".search-box a, .search-box .app-search .srh-btn").on('click', function () {
                    $(".app-search").toggle(200);
                    $(".app-search input").focus();
                });

                // ============================================================== 
                // Right sidebar options
                // ==============================================================
                $(function () {
                    $(".service-panel-toggle").on('click', function () {
                        $(".customizer").toggleClass('show-service-panel');

                    });
                    $('.page-wrapper').on('click', function () {
                        $(".customizer").removeClass('show-service-panel');
                    });
                });
                // ============================================================== 
                // This is for the floating labels
                // ============================================================== 
                $('.floating-labels .form-control').on('focus blur', function (e) {
                    $(this).parents('.form-group').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
                }).trigger('blur');

                // ============================================================== 
                //tooltip
                // ============================================================== 
                $(function () {
                    $('[data-toggle="tooltip"]').tooltip()
                })
                // ============================================================== 
                //Popover
                // ============================================================== 
                $(function () {
                    $('[data-toggle="popover"]').popover()
                });

                // ============================================================== 
                // Perfact scrollbar
                // ============================================================== 
                // new PerfectScrollbar.initialize('.message-center, .customizer-body, .scrollable', { 
                //     wheelPropagation: !0 
                // });

                /*var ps = new PerfectScrollbar('.message-body');
                var ps = new PerfectScrollbar('.notifications');
                var ps = new PerfectScrollbar('.scroll-sidebar');
                var ps = new PerfectScrollbar('.customizer-body');*/

                // ============================================================== 
                // Resize all elements
                // ============================================================== 
                $("body, .page-wrapper").trigger("resize");
                $(".page-wrapper").delay(20).show();
                // ============================================================== 
                // To do list
                // ============================================================== 
                $(".list-task li label").click(function () {
                    $(this).toggleClass("task-done");
                });
                // ============================================================== 
                // Collapsable cards
                // ==============================================================
                $('a[data-action="collapse"]').on('click', function (e) {
                    e.preventDefault();
                    $(this).closest('.card').find('[data-action="collapse"] i').toggleClass('ti-minus ti-plus');
                    $(this).closest('.card').children('.card-body').collapse('toggle');
                });
                // Toggle fullscreen
                $('a[data-action="expand"]').on('click', function (e) {
                    e.preventDefault();
                    $(this).closest('.card').find('[data-action="expand"] i').toggleClass('mdi-arrow-expand mdi-arrow-compress');
                    $(this).closest('.card').toggleClass('card-fullscreen');
                });
                // Close Card
                $('a[data-action="close"]').on('click', function () {
                    $(this).closest('.card').removeClass().slideUp('fast');
                });
                // ============================================================== 
                // LThis is for mega menu
                // ==============================================================
                $(document).on('click', '.mega-dropdown', function (e) {
                    e.stopPropagation()
                });
                // ============================================================== 
                // Last month earning
                // ==============================================================
                // var sparklineLogin = function() {
                //     $('.lastmonth').sparkline([6, 10, 9, 11, 9, 10, 12], {
                //         type: 'bar',
                //         height: '35',
                //         barWidth: '4',
                //         width: '100%',
                //         resize: true,
                //         barSpacing: '8',
                //         barColor: '#2961ff'
                //     });

                // };
                // var sparkResize;

                // $(window).resize(function(e) {
                //     clearTimeout(sparkResize);
                //     sparkResize = setTimeout(sparklineLogin, 500);
                // });
                // sparklineLogin();

                // ============================================================== 
                // This is for the innerleft sidebar
                // ==============================================================
                $(".show-left-part").on('click', function () {
                    $('.left-part').toggleClass('show-panel');
                    $('.show-left-part').toggleClass('ti-menu');
                });


                // Disable right click and f12

                $("html").on("contextmenu", function (e) {
                    return false;
                });
                $(document).keydown(function (event) {
                    if (event.keyCode == 123) { // Prevent F12
                        return false;
                    } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) { // Prevent Ctrl+Shift+I        
                        return false;
                    }
                });
            });
        }
    };

    return (
        // {...mainWrapperAttributes}
        <div id="main-wrapper" {...mainWrapperAttributes}>
            <TopBar themeSettings={themeSettings} getDataUser={getDataUser} getDataZonasAgencias={getDataZonasAgencias}/>
            <LeftSidebar scrollSidebar={scrollSidebar} themeSettings={themeSettings} getDataUser={getDataUser} getDataMenu={getDataMenu} />
            <PageWrapper  showSpinnerLoader={showSpinnerLoader} getDataUser={getDataUser} />
        </div>
    )
}

export default MainWrapper;